import type { MessageDescriptor } from "@lingui/core";
import { msg } from "@lingui/core/macro";
import { createIsomorphicFn, createServerFn } from "@tanstack/react-start";
import { setCookie } from "@tanstack/react-start/server";
import z from "zod";

const themeSchema = z.union([z.literal("light"), z.literal("dark")]);

export type Theme = z.infer<typeof themeSchema>;

const storageKey = "theme";
const defaultTheme: Theme = "light";

export const themeMap = {
	light: msg`Light`,
	dark: msg`Dark`,
} satisfies Record<Theme, MessageDescriptor>;

export function isTheme(theme: string): theme is Theme {
	return themeSchema.safeParse(theme).success;
}

export const getTheme = createIsomorphicFn()
	.client(() => {
		return "light" as Theme;
	})
	.server(async () => {
		return "light" as Theme;
	});

export const setThemeServerFn = createServerFn({ method: "POST" })
	.inputValidator(themeSchema)
	.handler(async ({ data }) => {
		setCookie(storageKey, data);
	});
